import type { TaskModalTask } from "@common/types";
import type { ConsumedTaskItem } from "@common/types/Inventory";

import Checkbox from "components/core/Checkbox";
import { Flex } from "components/core/Flex";
import { Text } from "components/core/Text";

import InventoryList from "./InventoryList";

type Props = {
  currentPage: number;
  setCurrentPage: (page: number) => void;
  showOnlyTaskGardenItems: boolean;
  setShowOnlyTaskGardenItems: (checked: boolean) => void;
  onChange: (item: ConsumedTaskItem) => void;
  task: Pick<TaskModalTask, "id" | "name" | "taskType">;
};

const InventoryUsage = ({
  onChange,
  task,
  currentPage,
  setCurrentPage,
  showOnlyTaskGardenItems,
  setShowOnlyTaskGardenItems
}: Props) => (
  <Flex direction="col" gap={4}>
    <Checkbox
      checked={showOnlyTaskGardenItems}
      onCheckedChange={(checked) => {
        setShowOnlyTaskGardenItems(checked);
        setCurrentPage(1);
      }}
    >
      <Text variant="caption">Show only items from current garden</Text>
    </Checkbox>
    <InventoryList
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      showOnlyTaskGardenItems={showOnlyTaskGardenItems}
      task={task}
      onChange={onChange}
    />
  </Flex>
);

export default InventoryUsage;
